const queryString =(params:any)=> Object.keys(params).filter(key=>params[key]).map((key) => {

        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    
}).join('&');

export default queryString;